import TabSection from "components/TabSection";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import AssingProjectLocation from "./AssingProjectLocation";
import CbboProjectList from "./CbboProjectList";
import FpoProjectList from "./FpoProjectList";

const AddProjectModal = ({
  employeeDataRefetch,
  employeeData,
  addProjectModel,
}) => {
  const [step, setStep] = useState(1);
  const [error, setError] = useState(false);

  const [selectedProjects, setSelectedProjects] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const selectedCbbo = JSON.parse(
        localStorage.getItem("selectedCbbo") || "{}"
      );
      const selectedFpo = JSON.parse(
        localStorage.getItem("selectedFpo") || "{}"
      );
      const hasSelection =
        Object.keys(selectedCbbo).length > 0 ||
        Object.keys(selectedFpo).length > 0;

      if (hasSelection && error) {
        setError(false);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [error]);

  const handleNext = (e) => {
    e.preventDefault();
    const selectedCbbo = JSON.parse(
      localStorage.getItem("selectedCbbo") || "{}"
    );
    const selectedFpo = JSON.parse(localStorage.getItem("selectedFpo") || "{}");
    const hasSelection =
      Object.keys(selectedCbbo).length > 0 ||
      Object.keys(selectedFpo).length > 0;

    if (!hasSelection) {
      setError(true);
      return;
    }
    setError(false);
    setStep((prev) => Math.min(prev + 1, 3));
  };

  const handleBack = () => setStep((prev) => Math.max(prev - 1, 1));

  return (
    <div>
      <div className="d-flex justify-content-between align-item-center">
        {step === 1 ? (
          <h5>Step: 1 - Select the Cbbo / Fpo for Project</h5>
        ) : (
          <h5>Step: 2 - Assign the Location</h5>
        )}

        <div className="text-end d-flex gap-3 align-items-center ">
          {error && (
            <p className="text-sm text-danger">
              Please Select the Cbbo / Fpo first
            </p>
          )}
          {step === 2 ? (
            <Button
              id="AddLeads"
              className="primary"
              size="sm"
              onClick={handleBack}
            >
              Back&nbsp;
            </Button>
          ) : (
            <Button
              id="AddLeads"
              className="primary"
              size="sm"
              onClick={(e) => handleNext(e)}
            >
              Next&nbsp;
            </Button>
          )}
        </div>
      </div>

      {step === 1 && (
        <TabSection
          tabsList={[
            {
              label: "CBBO LIST",
              component: (
                <CbboProjectList setSelectedProjects={setSelectedProjects} />
              ),
            },
            {
              label: "FPO LIST",
              component: (
                <FpoProjectList setSelectedProjects={setSelectedProjects} />
              ),
            },
          ]}
          currentTab={0}
        />
      )}

      {step === 2 && (
        <div>
          <AssingProjectLocation
            employeeDataRefetch={employeeDataRefetch}
            employeeData={employeeData}
            selectedProjects={selectedProjects}
            addProjectModel={addProjectModel}
          />{" "}
        </div>
      )}
    </div>
  );
};

export default AddProjectModal;
